<template>
    <FormSection title="Providers" type="his-section" :full-height="false" :application-id="palliativeApplication">
        <template #content>
            <section class="col-12 flex-row py-2 px-3 row g-0 mb-2">
                <div class="form-group col-12 col-lg-4 pe-lg-3">
                    <label> Primary Care Provider </label>
                    <TypeaheadInput
                        id="Primary-Care-Provider"
                        :getData="getPhysicianList"
                        v-on:valueChanged="attendingPhysicianChangedPrimaryCare"
                        placeholder="Start Typing..."
                        :value="primaryCareProvider"
                    />
                    <div v-if="primaryCareProviderInfo.firstName && !isLoadingPrimaryCare">
                        <ContactInfoCard :contactInformation="primaryCareProviderInfo" />
                    </div>
                    <div v-if="isLoadingPrimaryCare">
                        <ContactInfoLoading />
                    </div>
                </div>
                <div class="form-group col-12 col-lg-4 pe-lg-3">
                    <label> Palliative Provider <span class="text-danger">*</span></label>
                    <TypeaheadInput
                        id="Palliative-Provider"
                        :getData="getPhysicianList"
                        v-on:valueChanged="attendingPhysicianChangedPalliativeCare"
                        placeholder="Start Typing..."
                        :init-value="palliativeProvider"
                        v-on:blurredInput="v$.patientDetails.providers.palliativeProviderId.$touch"
                        :class="`${v$.patientDetails.providers.palliativeProviderId.$error ? 'field-invalid' : ''}`"
                    />
                    <div v-if="palliativeCareProviderInfo.firstName && !isLoadingPalliativeCare">
                        <ContactInfoCard :contactInformation="palliativeCareProviderInfo" />
                    </div>
                    <div v-if="isLoadingPalliativeCare">
                        <ContactInfoLoading />
                    </div>
                    <span v-if="v$.patientDetails.providers.palliativeProviderId.$error" class="field-invalid"
                        >Palliative Provider is required.</span
                    >
                </div>
                <div class="form-group col-12 col-lg-4 pe-lg-3">
                    <label> Referring Provider </label>
                    <TypeaheadInput
                        :getData="getPhysicianList"
                        v-on:valueChanged="attendingPhysicianChangedReferring"
                        placeholder="Search Referring Provider"
                        :init-value="referringProvider"
                    />
                    <div v-if="referringProviderInfo.firstName && !isLoadingReferringCare">
                        <ContactInfoCard :contactInformation="referringProviderInfo" />
                    </div>
                    <div v-if="isLoadingReferringCare">
                        <ContactInfoLoading />
                    </div>
                </div>
                <div
                    v-for="(provider, index) of additionalProvider"
                    :key="index"
                    class="form-group col-12 col-lg-4 pe-lg-3"
                >
                    <label> Additional Provider </label>
                    <TypeaheadInput
                        :getData="getPhysicianList"
                        v-on:valueChanged="(e) => attendingPhysicianChangedOther(e, index)"
                        placeholder="Start Typing..."
                        :init-value="additionalProvider[index]"
                    />
                    <div v-if="additionalProviderInfo[index].firstName && !isLoadingAdditionalProvider[index]">
                        <ContactInfoCard :contactInformation="additionalProviderInfo[index]" />
                    </div>
                    <div v-if="isLoadingAdditionalProvider[index]">
                        <ContactInfoLoading />
                    </div>
                </div>
                <button type="button" class="btn my-4 btn-outline-primary w-10 h-10 px-1" @click="addProvider">
                    <b class="fw-bolder h6">+</b>
                    Add Provider
                </button>
            </section>
        </template>
    </FormSection>
</template>

<script lang="ts" src="./Providers.ts"></script>
